import React, { ReactNode } from "react";
import styled from '@emotion/styled';
import { boldTypes, colors } from "src/theme";
import { MergeWithOverwrite, mq } from "src/common";

export type FontSize = "xxxxLarge" | "xxxLarge" | "xxLarge" | "xLarge" | "sLarge" | "large" | "medium" | "base" | "sBase" | "small" | "tiny" | "micro";

const typographyConfig = {
  xxxxLarge:
    mq({
      fontSize: ['40px', '40px', '48px', '48px', '60px'],
      lineHeight: 1.2,
    })[0],
  xxxLarge:
    mq({
      fontSize: ['32px', '32px', '40px', '40px', '48px'],
      lineHeight: 1.16,
    })[0],
  xxLarge:
    mq({
      fontSize: ['32px', '32px', '36px', '36px', '40px'],
      lineHeight: 1.20,
    })[0],
  xLarge:
    mq({
      fontSize: ['24px', '24px', '28px', '28px', '32px'],
      lineHeight: 1.25,
    })[0],
  sLarge:
    mq({
      fontSize: ['20px', '20px', '24px', '24px', '28px'],
      lineHeight: 1.25,
    })[0],
  large: {
    fontSize: '24px',
    lineHeight: '28px',
  },
  medium: {
    fontSize: '20px',
    lineHeight: '24px',
  },
  base: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  sBase:
  mq({
    fontSize: ['14px', '14px', '16px', '16px', '16px'],
    lineHeight: 1.25,
  })[0],
  small: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  tiny: {
    fontSize: '12px',
    lineHeight: '16px',
  },
  micro: {
    fontSize: '11px',
    lineHeight: '16px',
  }
};

const TextStyle = styled.div((props: { type: FontSize, color: string, bold: boolean, italic: boolean }) => ({
  ...typographyConfig[props.type],
  color: props.color,
  fontStyle: props.italic ? 'italic' : 'normal',
  fontWeight: props.bold ? boldTypes.bold : boldTypes.normal,
}));

export type TextProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLDivElement>, {
  type: FontSize;
  color?: string;
  bold?: boolean; // trenutno ima samo dvije razina bold-a
  italic?: boolean;
  children?: ReactNode;
  className?: string;
  dangerouslySetInnerHTML?: { __html: string };
}>;

export const Text = ({ type, color = colors.text1, bold = false, italic = false, children, className, dangerouslySetInnerHTML }: TextProps) => (
  <TextStyle type={type} color={color} bold={bold} italic={italic} className={className} dangerouslySetInnerHTML={dangerouslySetInnerHTML}>
    {children}
  </TextStyle>
);
